

import UserPersistence from "../persistence/UserPersistence";
import {get, post, put} from "./Http"

//查询影像中心的详情
function getinvoice(params) { return post("/api-invoice-imagecenter/file/getImageInfo", params)}

  
//查询影像中心上传
function uploadInvoice(params,abId){ return post(`/api-invoice-imagecenter/file/uploadWithOcr?uploadType=1&abId=${abId}`, params)}

//税收分类
function queryTaxByParentId(params){return post("/api-finbasic/basictaxclass/queryTaxByParentId", params)}
//影响中心保存
function saveInvoice(params) { return post("/api-invoice-imagecenter/file/save", params)}

// 改变发票类型保存
function  savechnageInvoice(params) { return post("/api-invoice-imagecenter/file/adjustAndSave", params)}

//查询税收分类树状
function TaxList(params) { return get("/api-finbasic/basictaxclass/queryAbbTree", params)}
//平台采集上传
function uploadPlatForm(params) { return post('/api-invoice-imagecenter/file/uploadWithOcrFromEdu',params) } 
//平台列表
function getAttachmentList(params){ return get(`/api-finbasic/common/findFileList?questionId=${params}`) } 
export default {
    getinvoice,
    uploadInvoice,
    queryTaxByParentId,
    saveInvoice,
    savechnageInvoice,
    TaxList,
    uploadPlatForm,
    getAttachmentList

    


}


// WEBPACK FOOTER //
// ./src/api/invoice-collect.js